<template>
  <div>
    <div>
      <h4>{{ playerCharacter.name }}</h4>
      <p> Round Number: {{ watcherDoc.roundCount }}</p> 
      <h5>Round Initiative</h5>
      <div class="initiativeInputs">
        <div class="input-field inline">
          <input 
            id="initiative"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="2"
            class="validate initiative"
            v-model="localInitiativeProtectedFromDatabaseShenanigans"
            placeholder="0"
            ref="initiativeInput"
            @blur="$emit('entity-update', playerCharacter, 'initiative')"
            >
          <span class="helper-text" data-error="wrong" data-success="good job">1st</span>
        </div>
        <!-- <span style="font-size:7em;">&nbsp;</span> -->
        <div class="input-field inline">
          <input
            id="subInitiative"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="2"
            class="validate initiative"
            v-model="playerCharacter.subInitiative"
            placeholder="?"
            ref="subInitiativeInput"
            @blur="$emit('entity-update', playerCharacter, 'subInitiative')"
            >
          <span class="helper-text" data-error="wrong" data-success="good job">2nd</span>
        </div>
      </div>
      <br/>
      <div class="buttonDiv">
        <div class="buttonContainer">
          <button :disabled="!initativesReady" class="waves-effect waves-light btn-large" type="submit" name="action" @click="submitInitiatives">Submit
            <i class="material-icons right">send</i>
          </button>
        </div>
        <div class="buttonContainer">
          <button class="waves-effect waves-light btn-large black" type="submit" name="action" @click="exhaustPlayer">
            I am Exhausted!
            <i class="material-icons right">send</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EntityList from '@/components/EntityList'

export default {
  name: 'RoundPrep',
  components: { EntityList },
  props: [
    'entitiesHaveLoaded',
    'playerCharacter',
    'bugs',
    'acceptedFeatures',
    'ideas',
    'watcherDoc'
    ],
  data () {
    return {
      pageName: 'RoundPrep',
      localInitiativeProtectedFromDatabaseShenanigans: '',
    }
  },
  methods: {
    exhaustPlayer() {
      this.$emit('update-presence', this.playerCharacter, false)
      this.$router.push({ name: 'TurnOrder' })
    },
    submitInitiatives() {
      this.$router.push({ name: 'TurnOrder', params: { name:this.playerCharacter.name } })
    }
  },
  computed: {
    initiative() {
      return this.playerCharacter.initiative
    },
    initativesReady() {
      return this.playerCharacter.initiative && this.playerCharacter.subInitiative
    }
  },
  watch: {
    localInitiativeProtectedFromDatabaseShenanigans(newVal, oldVal) {
      this.playerCharacter.initiative = this.localInitiativeProtectedFromDatabaseShenanigans
      console.log(`***initiative changed [${newVal}] <- [${oldVal}]`)
      if (newVal.length > 1 && oldVal.length < 2) {
        this.$refs.subInitiativeInput.focus()
      }
    }
  },
  created() {
    // if (!this.playerCharacter.id) {
    //   this.playerCharacter.name = 'no character chosen?'
    //   this.$router.push('ScenarioStart')
    // }
    this.playerCharacter.initiative = ''
    this.$emit('entity-update', this.playerCharacter, "initiative")
    this.playerCharacter.subInitiative = ''
    this.$emit('entity-update', this.playerCharacter, "subInitiative")
  
    console.log('set initiative of playerCharacter to empty [', this.playerCharacter.initiative, ']', this.playerCharacter, this.playerCharacter.initiative)

    this.watcherDoc.readyToRestartRound = false
    this.$emit('watcherdoc-update','readyToRestartRound')
    this.watcherDoc.elementsReduced = false
    this.$emit('watcherdoc-update','elementsReduced')
    this.watcherDoc.allShufflesShuffled = false
    this.$emit('watcherdoc-update','allShufflesShuffled')
  },
  mounted() {
    this.$refs.initiativeInput.focus()
  },
}
</script>

<style scoped>
.initiativeInputs {
  width: 100%;
}
.initiativeInputs > .input-field {
  width: 40%;
}
input.initiative {
  font-size: 7em;
  height: 7rem;
  text-align: center;
}
.buttonDiv{
  display: grid;
  grid-row-gap: 50px;
}
.black{
  color: rgb(162, 40, 40);
}
</style>


// WEBPACK FOOTER //
// src/components/RoundPrep.vue